export default "9a6c965283206a37.svg"